import { USER_TOKEN } from '../constants/user';

const initialState = {
  token: '',
};

const userTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    default:
      return state;
  }
};
export default userTokenReducer;
